import React from "react";
// import DATA from "./Data";
// import MaterialTable from "material-table";
import { withSnackbar } from "notistack";

class LanguagesTablePage extends React.Component {
  render() {
    return (
      <div>Languages</div>
    );
  }
}
export default withSnackbar(LanguagesTablePage);
